import React, { useState } from 'react';
import FormSelect from '../../Songs/components/FormSelect';
import { toast } from '../../../components/shared/toast';

const OWNERSHIP_OPTIONS = [
  { key: 'is_singer', label: 'Singer' },
  { key: 'is_lyrics', label: 'Lyrics' },
  { key: 'is_musician', label: 'Musician' },
  { key: 'is_recordlabel', label: 'Record Label' }
];

function AddSongModal({ isOpen, onClose, onAddSong, existingSongIds = [], t }) {
  const [selectedSongId, setSelectedSongId] = useState('');
  const [ownershipFlags, setOwnershipFlags] = useState({
    is_singer: 1,
    is_lyrics: 0,
    is_musician: 0,
    is_recordlabel: 0
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (!isOpen) return null;

  const toggleFlag = (key) => {
    setOwnershipFlags(prev => ({
      ...prev,
      [key]: prev[key] === 1 ? 0 : 1
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedSongId) {
      toast.warning('Please select a song to add.');
      return;
    }

    if (!ownershipFlags.is_singer && !ownershipFlags.is_lyrics && !ownershipFlags.is_musician && !ownershipFlags.is_recordlabel) {
      toast.warning('Please select at least one ownership type.');
      return;
    }

    try {
      setIsSubmitting(true);
      await onAddSong({
        song_id: selectedSongId,
        is_singer: ownershipFlags.is_singer ? 1 : 0,
        is_lyrics: ownershipFlags.is_lyrics ? 1 : 0,
        is_musician: ownershipFlags.is_musician ? 1 : 0,
        is_recordlabel: ownershipFlags.is_recordlabel ? 1 : 0
      });
      setSelectedSongId('');
      setOwnershipFlags({ is_singer: 1, is_lyrics: 0, is_musician: 0, is_recordlabel: 0 });
      onClose();
    } catch (err) {
      console.error('Error adding song:', err);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div 
      className="modal-overlay"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(15, 23, 42, 0.6)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999
      }}
    >
      <div 
        className="modal-content"
        style={{
          background: '#ffffff',
          borderRadius: '16px',
          width: '90%',
          maxWidth: '480px',
          padding: '24px',
          boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1)'
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <h3 style={{ fontSize: '18px', fontWeight: '700', margin: 0, color: '#0f172a' }}>
            {t ? (t('ownership.addSongModal.title') || 'Add Song to Ownership') : 'Add Song to Ownership'}
          </h3>
          <button 
            type="button" 
            onClick={onClose}
            style={{ border: 'none', background: 'transparent', cursor: 'pointer', color: '#64748b', fontSize: '20px' }}
          >
            &times;
          </button>
        </div>

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          {/* Select Song */}
          <div className="form-field-group">
            <FormSelect
              label={t ? (t('ownership.addSongModal.songLabel') || 'Select Song') : 'Select Song'}
              required={true}
              isLazy={true}
              lazyType="songs"
              value={selectedSongId}
              onChange={setSelectedSongId}
              excludeIds={existingSongIds}
              isMulti={false}
              placeholder="Search and select song"
            />
          </div>

          {/* Select Ownership Types */}
          <div className="form-field-group" style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <label className="form-field-label" style={{ fontSize: '13px', fontWeight: '600', color: '#334155' }}>
              Ownership Types <span className="required-asterisk" style={{ color: '#ef4444' }}>*</span>
            </label>
            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
              {OWNERSHIP_OPTIONS.map(opt => {
                const isChecked = ownershipFlags[opt.key] === 1;
                return (
                  <label
                    key={opt.key}
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '6px',
                      padding: '6px 12px',
                      borderRadius: '8px',
                      border: `1px solid ${isChecked ? '#3b82f6' : '#cbd5e1'}`,
                      backgroundColor: isChecked ? '#eff6ff' : '#ffffff',
                      color: isChecked ? '#1d4ed8' : '#475569',
                      fontSize: '13px',
                      fontWeight: isChecked ? '600' : '500',
                      cursor: 'pointer',
                      userSelect: 'none',
                      transition: 'all 0.15s ease'
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={isChecked}
                      onChange={() => toggleFlag(opt.key)}
                      style={{ cursor: 'pointer', accentColor: '#3b82f6', width: '15px', height: '15px' }}
                    />
                    <span>{opt.label}</span>
                  </label>
                );
              })}
            </div>
          </div>

          {/* Footer Actions */}
          <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end', marginTop: '12px' }}>
            <button
              type="button"
              onClick={onClose}
              style={{
                padding: '10px 18px',
                borderRadius: '8px',
                border: '1px solid #cbd5e1',
                background: '#ffffff',
                color: '#475569',
                fontWeight: '600',
                cursor: 'pointer'
              }}
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={isSubmitting}
              style={{
                padding: '10px 18px',
                borderRadius: '8px',
                border: 'none',
                background: '#3b82f6',
                color: '#ffffff',
                fontWeight: '600',
                cursor: isSubmitting ? 'not-allowed' : 'pointer',
                opacity: isSubmitting ? 0.7 : 1
              }}
            >
              {isSubmitting ? 'Adding...' : 'Add Song'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddSongModal;
